export default __webpack_public_path__ + "static/tallinn-4244d0139df518b112ec77dee6fa019d.jpg";